'use strict';

/** Visible + accessible phrase. Never a grant claim. No application serial. */
export const US_PATENT_PENDING_LABEL = 'US PATENT PENDING';
